var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"$splitLayout",staticClass:"lc-am-split-layout",class:_vm.splitLayoutExtraClassNames,on:{"mouseup":_vm.handleMouseUp,"mouseleave":_vm.handleMouseUp,"mousemove":_vm.handleMouseMove}},[_vm._t("default"),(_vm.resizable)?_c('div',{class:[
      'lc-am-split-handler',
      _vm.isColumnMode ? 'handler-horizontal' : 'handler-vertical',
      _vm.isResizing ? 'handler-actived' : void 0 ],style:(_vm.handlerStyle),on:{"mousedown":_vm.handleMouseDown}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }